import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, X } from 'lucide-react';
export function WhoItsFor() {
  const isFor = ['Women 45-60+ waking up 3+ times a night.', 'Professional women who cannot afford another day of "menopause brain fog."', 'Anyone exhausted by the "Wired-Tired" feeling.', 'Women seeking a non-hormonal, drug-free way to reclaim their nights.'];
  const notFor = ['People looking for a "magic pill" or medical prescriptions.', 'Those unwilling to change their 3 AM habits (like checking the phone).', 'Men (this is specifically engineered for the female hormonal profile).'];
  return <section className="py-16 md:py-24 px-4" data-id="element-178">
      <div className="max-w-5xl mx-auto" data-id="element-179">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-180">
          {/* Who it's for */}
          <FadeIn direction="right" data-id="element-181">
            <div className="bg-night-800/50 rounded-2xl p-8 border border-night-700 h-full" data-id="element-182">
              <h3 className="font-serif text-2xl md:text-3xl text-white mb-8 border-b border-night-700 pb-4" data-id="element-183">
                Who This Is For
              </h3>
              <ul className="space-y-6" data-id="element-184">
                {isFor.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-185">
                    <div className="bg-green-500/20 p-1 rounded-full shrink-0 mt-1" data-id="element-186">
                      <Check className="w-4 h-4 text-green-400" data-id="element-187" />
                    </div>
                    <span className="text-cream/90 leading-relaxed" data-id="element-188">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Who it's not for */}
          <FadeIn direction="left" delay={0.2} data-id="element-189">
            <div className="bg-night-900/50 rounded-2xl p-8 border border-night-800 h-full" data-id="element-190">
              <h3 className="font-serif text-2xl md:text-3xl text-white/70 mb-8 border-b border-night-800 pb-4" data-id="element-191">
                Who This Is NOT For
              </h3>
              <ul className="space-y-6" data-id="element-192">
                {notFor.map((item, i) => <li key={i} className="flex items-start gap-4 opacity-70" data-id="element-193">
                    <div className="bg-red-500/20 p-1 rounded-full shrink-0 mt-1" data-id="element-194">
                      <X className="w-4 h-4 text-red-400" data-id="element-195" />
                    </div>
                    <span className="text-cream/80 leading-relaxed" data-id="element-196">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}